import React from 'react';
import { Navbar } from 'reactstrap';
import classNames from 'classnames';
import NavbarUser from './NavbarUser';

import QaseLogo from '../../../assets/images/logo/logo.png';
import { Link } from 'react-router-dom';
import GlobalSearch from './GlobalSearch';
import { useSelector } from 'react-redux';
import { getUserSource } from '../../../redux/selectors';
import { useEffect } from 'react';
import { useState } from 'react';
import SourceRepository from '../../../repositories/SourceRepository';

const QaseNavbar = ({ leftSpace = true }) => {
    const sourceId = useSelector(getUserSource);
    const [showSearch, setShowSearch] = useState(false);
    useEffect(() => {
        if (sourceId) {
            //get source
            (async (sourceId) => {
                const response = await SourceRepository.getSourceById(sourceId);
                if (response.data.success && !!response.data?.data?.config) {
                    let config = JSON.parse(response.data.data.config);

                    setShowSearch(config?.enableGlobalSearch || false);
                }
            })(sourceId);
        }
    }, [sourceId]);

    return (
        <Navbar
            className={classNames('header-navbar navbar-light', {
                'left-space': leftSpace,
            })}
            expand="lg"
            light
            fixed="top"
        >
            {!leftSpace && (
                <Link className="navbar-brand" to="/">
                    <img
                        src={QaseLogo}
                        alt="Qase"
                        style={{ maxHeight: '32px' }}
                    />
                </Link>
            )}
            {showSearch && <GlobalSearch />}
            <NavbarUser />
        </Navbar>
    );
};

export default QaseNavbar;
